import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  DialogActions,
  Tooltip,
  IconButton,
} from '@mui/material';
import RedesignCard from './Card';
import DialogBoxYt from '../Widgets/DialogBoxYt';
import DialogBoxVimeo from '../Widgets/DialogBoxVimeo';
import DefaultWidget from '../Widgets/DefaultWidget';
import DialogBoxWebsite from '../Widgets/DialogBoxWebSite';
import DialogBoxEmbed from '../Widgets/DialogBoxEmbed';
import DialogBoxScrollingStrip from '../Widgets/DialogBoxScrollingStrip';
import DialogBoxWeather from '../Widgets/DialogBoxWeather';
import DialogBoxCanva from '../Widgets/DialogBoxCanva';
import DialogBoxPostermywall from '../Widgets/DialogBoxPostermywall';
import DialogBoxSplitScreen from '../Widgets/DialogBoxSplitScreen';
import DialogBoxYoutubePlaylist from '../Widgets/DialogBoxYoutubePlaylist';
import DialogBoxTwitchPlaylist from '../Widgets/DialogBoxTwitchPlaylist';
import {
  DialogBoxLiveYoutube,
  DialogBoxLiveTwitch,
  DialogBoxLiveVimeo,
} from '../Widgets/DialogBoxLive';

import useUserFeature from '../../../hooks/use-user-feature';

import './createWidgetModelStyles.css'
import CloseIcon from '@mui/icons-material/Close';

import { baseImg } from '../../../api/endpoints';
import { useMediaQuery } from 'react-responsive';
import { useLocation } from 'react-router-dom';
import DialogPMWcreator from '../Widgets/DialogPMWcreator';
import { useSelector } from 'react-redux';

const widget = {
  default: DefaultWidget,
  youtube: DialogBoxYt,
  vimeo: DialogBoxVimeo,
  website: DialogBoxWebsite,
  embed: DialogBoxEmbed,
  scrollingstrip: DialogBoxScrollingStrip,
  weather: DialogBoxWeather,
  canva: DialogBoxCanva,
//   postermywall: DialogBoxPostermywall,
  postermywall: DialogPMWcreator,
  spiltscreen: DialogBoxSplitScreen,
  youtubeplaylist: DialogBoxYoutubePlaylist,
  twitch: DialogBoxTwitchPlaylist,
  live_youtube: DialogBoxLiveYoutube,
  live_twitch: DialogBoxLiveTwitch,
  live_vimeo: DialogBoxLiveVimeo,
};

const AppBox = ({ widget, onClickWidget, disabled }) => {
  const { widgetsFeatures } = useSelector((state) => state.FeaturesLocks);
  console.log(widgetsFeatures)
  if (widgetsFeatures?.find(w => w.featureSlug == widget.slug.replace('spiltscreen', 'split_screen').replace('youtubeplaylist', 'yt_playlist'))) {
    disabled = widgetsFeatures?.find(w => w.featureSlug == widget.slug.replace('spiltscreen', 'split_screen').replace('youtubeplaylist', 'yt_playlist')).lock
  }
  const { t } = useTranslation();  
  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };  
  return (
    <Tooltip title={disabled ? `${t("views.redesignCard.applicationNotAvailable")} Or it's locked` : ""}>
      <div
        onClick={() => !disabled && onClickWidget({ slug: widget?.slug, icon: widget?.img })}
        role='button'
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
          width: "160px",
          cursor: !disabled ? "pointer" : "auto"
        }}
      >
        <img
          src={widget?.img}
          alt='Icon'
          style={{
            width: '100%',
            height: '70px',
            objectFit: 'contain',
            filter: disabled ? 'grayscale(1)' : 'grayscale(0)',
          }}
        />
        <Typography color="text.secondary" variant="body2" sx={{ textAlign: "center" }}>{capitalizeFirstLetter(widget?.name)}</Typography>
      </div>
    </Tooltip>
  );
};

function CreateWidgetModel({
  isOpen,
  onClose,
  onAddWidget,
  onAddContent,
  onTakeData,
  setRefreshData,
  user,
}) {
  const { t } = useTranslation();
  const [widgetName, setWidgetName] = useState('default');
  const [widgetIcon, setWidgetIcon] = useState('');
  const [openWidget, setOpenWidget] = useState(false);
  const Component = widget[widgetName];
  const isMobile = useMediaQuery({ query: '(max-width: 786px)' });
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has("pmw")) {
        onOpenWidgetFile({slug: 'postermywall', icon: '/images/postermywallLogo.png'})
        onClose()
    }
  }, []);

  const widgetsList = [
    {
      id: 1,
      name: 'youtube',
      slug: 'youtube',
      apiSlug: 'youtube_app',
      img: '/images/youtubeIcon.png',
    },
    {
      id: 2,
      name: 'weather',
      slug: 'weather',
      apiSlug: 'weather_app',
      img: '/images/weather-widget.png',
    },
    {
      id: 3,
      name: 'vimeo',
      slug: 'vimeo',
      apiSlug: 'vimeo_app',
      img: '/images/vimeoIcon.png',
    },
    {
      id: 4,
      name: 'website',
      slug: 'website',
      apiSlug: 'website_app',
      img: '/images/websiteIcon2.png',
    },
    {
      id: 5,
      name: 'embed',
      slug: 'embed',
      apiSlug: 'embed_app',
      img: '/images/embedIcon.png',
    },
    {
      id: 6,
      name: 'scrolling Strip',
      slug: 'scrollingstrip',
      apiSlug: 'scrolling_script_app',
      img: '/images/scrollingStripIcon.png',
    },
    {
      id: 7,
      name: 'Canva',
      slug: 'canva',
      apiSlug: 'canva_app',
      img: '/images/canvaLogo.svg',
    },
    {
      id: 8,
      name: 'Postermywall',
      slug: 'postermywall',
      apiSlug: 'postermywall_app',
      img: '/images/postermywallLogo.png',
    },
    {
      id: 9,
      name: 'Spilt Screen',
      slug: 'spiltscreen',
      apiSlug: 'split_screen',
      img: '/images/VCPsplitscreenlogo.png',
    },
    {
      id: 10,
      name: 'Youtube Playlist',
      slug: 'youtubeplaylist',
      apiSlug: 'yt_playlist',
      img: '/images/yt_app.png',
    },
    {
      id: 11,
      name: 'Twitch',
      slug: 'twitch',
      apiSlug: 'twitch_app',
      img: '/images/twitch_app.png',
    },
  ];
  const liveWidgetsList = [
    // { id: 101, name: 'YouTube Live', slug: 'live_youtube', apiSlug: 'live_youtube_app', img: '/images/youtubeIcon.png' },
    // { id: 102, name: 'Twitch Live', slug: 'live_twitch', apiSlug: 'live_twitch_app', img: '/images/twitch_app.png' },
    // { id: 103, name: 'Vimeo Live', slug: 'live_vimeo', apiSlug: 'live_vimeo_app', img: '/images/vimeoIcon.png' },
  ];
  const isLiveDisabled = (w) => {
    const feature = user?.plan?.planFeatures?.find((f) => f.slug == w.apiSlug);
    return feature ? !feature.enabled : false;
  };
  const onOpenWidgetFile = (obj) => {
    setOpenWidget(true);
    setWidgetName(obj.slug);
    setWidgetIcon(obj.icon);
    onClose();
  };
  return (
    <>
      <Component
        isNew={true}
        onAddWidget={onAddWidget}
        setRefreshData={setRefreshData}
        onAddContent={onAddContent}
        isOpen={openWidget}
        onTakeData={(data) => onTakeData(data)}
        onClose={(close) => setOpenWidget(close)}
        isIcon={widgetIcon}
      />
      <Dialog open={isOpen} onClose={() => onClose(false)} fullWidth maxWidth={"sm"}>
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2
        }}>
          <div></div>
          <DialogTitle textAlign="center">{t('views.createWidgetModel.selectApp')}</DialogTitle>
          <IconButton onClick={() => onClose(false)}>
            <CloseIcon/>
          </IconButton>
        </Box>
        <DialogContent
          // sx={{
          //   width: isMobile ? '280px' : '600px',
          //   height: isMobile ? '320px' : '610px',
          // }}
        >
          <Box
            sx={{
              // height: isMobile ? '300px' : '590px',
              // width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <form encType='multipart/form-data'>
              <input
                type={'file'}
                hidden
                id='click-browser-computer'
                multiple
                //   onChange={fileUpload}
              />
            </form>

            {/* <Typography
              variant={"caption"}
              sx={{
                color: "#92959E",
                fontFamily: "open sans",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "12px",
                paddingTop: isMobile ? "260px":"210px",
              }}
            >
              {t("views.createWidgetModel.customizeScreen")}
            </Typography> */}
            <Box
              sx={{
                // width: isMobile ? '240px' : '490px',
                margin: '10px auto',
                marginTop: 0,
                borderRadius: '10px',
                display: 'flex',
                flexWrap: 'wrap',
                gap: isMobile ? '8px' : '20px',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'row',
              }}
            >
              {isMobile && [...widgetsList, ...liveWidgetsList].map((widget) => (
                <RedesignCard
                  widget={widget}
                  onClickWidget={onOpenWidgetFile}
                  disabled={
                    user?.plan?.planFeatures?.find(
                      (f) => f.slug == widget.apiSlug
                    )
                      ? !user?.plan?.planFeatures?.find(
                          (f) => f.slug == widget.apiSlug
                        ).enabled
                      : false
                  }
                />
              ))}
              {!isMobile && (
                <table className='app-box-table'>
                  <tr>
                    <td>
                      <AppBox 
                        widget={widgetsList[0]}
                        onClickWidget={onOpenWidgetFile}
                        disabled={
                          user?.plan?.planFeatures?.find(
                            (f) => f.slug == widgetsList[0].apiSlug
                          )
                            ? !user?.plan?.planFeatures?.find(
                                (f) => f.slug == widgetsList[0].apiSlug
                              ).enabled
                            : false
                        }                      
                      />
                    </td>
                    <td>
                      <AppBox 
                        widget={widgetsList[1]}
                        onClickWidget={onOpenWidgetFile}
                        disabled={
                          user?.plan?.planFeatures?.find(
                            (f) => f.slug == widgetsList[1].apiSlug
                          )
                            ? !user?.plan?.planFeatures?.find(
                                (f) => f.slug == widgetsList[1].apiSlug
                              ).enabled
                            : false
                        }                      
                      />
                    </td>      
                    <td>
                      <AppBox 
                        widget={widgetsList[2]}
                        onClickWidget={onOpenWidgetFile}
                        disabled={
                          user?.plan?.planFeatures?.find(
                            (f) => f.slug == widgetsList[2].apiSlug
                          )
                            ? !user?.plan?.planFeatures?.find(
                                (f) => f.slug == widgetsList[2].apiSlug
                              ).enabled
                            : false
                        }                      
                      />
                    </td>                                  
                  </tr>
                  <tr>
                    <td>
                      <AppBox 
                        widget={widgetsList[3]}
                        onClickWidget={onOpenWidgetFile}
                        disabled={
                          user?.plan?.planFeatures?.find(
                            (f) => f.slug == widgetsList[3].apiSlug
                          )
                            ? !user?.plan?.planFeatures?.find(
                                (f) => f.slug == widgetsList[3].apiSlug
                              ).enabled
                            : false
                        }                      
                      />
                    </td>
                    <td>
                      <AppBox 
                        widget={widgetsList[4]}
                        onClickWidget={onOpenWidgetFile}
                        disabled={
                          user?.plan?.planFeatures?.find(
                            (f) => f.slug == widgetsList[4].apiSlug
                          )
                            ? !user?.plan?.planFeatures?.find(
                                (f) => f.slug == widgetsList[4].apiSlug
                              ).enabled
                            : false
                        }                      
                      />
                    </td>      
                    <td>
                      <AppBox 
                        widget={widgetsList[5]}
                        onClickWidget={onOpenWidgetFile}
                        disabled={
                          user?.plan?.planFeatures?.find(
                            (f) => f.slug == widgetsList[5].apiSlug
                          )
                            ? !user?.plan?.planFeatures?.find(
                                (f) => f.slug == widgetsList[5].apiSlug
                              ).enabled
                            : false
                        }                      
                      />
                    </td>                                  
                  </tr>  
                  <tr>
                    <td>
                      <AppBox 
                        widget={widgetsList[6]}
                        onClickWidget={onOpenWidgetFile}
                        disabled={
                          user?.plan?.planFeatures?.find(
                            (f) => f.slug == widgetsList[6].apiSlug
                          )
                            ? !user?.plan?.planFeatures?.find(
                                (f) => f.slug == widgetsList[6].apiSlug
                              ).enabled
                            : false
                        }                      
                      />
                    </td>
                    <td>
                      <AppBox 
                        widget={widgetsList[7]}
                        onClickWidget={onOpenWidgetFile}
                        disabled={
                          user?.plan?.planFeatures?.find(
                            (f) => f.slug == widgetsList[7].apiSlug
                          )
                            ? !user?.plan?.planFeatures?.find(
                                (f) => f.slug == widgetsList[7].apiSlug
                              ).enabled
                            : false
                        }                      
                      />
                    </td>      
                    <td>
                      <AppBox 
                        widget={widgetsList[8]}
                        onClickWidget={onOpenWidgetFile}
                        disabled={
                          user?.plan?.planFeatures?.find(
                            (f) => f.slug == widgetsList[8].apiSlug
                          )
                            ? !user?.plan?.planFeatures?.find(
                                (f) => f.slug == widgetsList[8].apiSlug
                              ).enabled
                            : false
                        }                      
                      />
                    </td>                                  
                  </tr>       
                  <tr>
                    <td>
                      <AppBox 
                        widget={widgetsList[9]}
                        onClickWidget={onOpenWidgetFile}
                        disabled={
                          user?.plan?.planFeatures?.find(
                            (f) => f.slug == widgetsList[9].apiSlug
                          )
                            ? !user?.plan?.planFeatures?.find(
                                (f) => f.slug == widgetsList[9].apiSlug
                              ).enabled
                            : false
                        }                      
                      />
                    </td>
                    <td>
                      <AppBox 
                        widget={widgetsList[10]}
                        onClickWidget={onOpenWidgetFile}
                        disabled={
                          user?.plan?.planFeatures?.find(
                            (f) => f.slug == widgetsList[10].apiSlug
                          )
                            ? !user?.plan?.planFeatures?.find(
                                (f) => f.slug == widgetsList[10].apiSlug
                              ).enabled
                            : false
                        }                      
                      />
                    </td>      
                    <td>
                    </td>                                  
                  </tr>                                              
                </table>
              )}
              {!isMobile && (
                <Box sx={{ width: '100%', mt: 2 }}>
                  <Typography variant='overline' color='text.secondary'>
                    {/* Live */}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: '20px', mt: 1 }}>
                    {liveWidgetsList.map((w) => (
                      <AppBox
                        key={w.slug}
                        widget={w}
                        onClickWidget={onOpenWidgetFile}
                        disabled={isLiveDisabled(w)}
                      />
                    ))}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </DialogContent>
        {/* <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button onClick={() => onClose(false)}>
            {t('views.createWidgetModel.close')}
          </Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
}

export default CreateWidgetModel;
